import { useOutletContext } from 'react-router-dom';
import { CalendarPage } from './CalendarPage';
import type { ShellOutletContext } from '../../shell/AppShell';

/**
 * The calendar inside the shell. An event is owned by the person creating it,
 * and until a session names one the shell's own viewer does — the same person
 * every other write here is attributed to. The grid renders in that viewer's
 * own zone, read once by the frame rather than fetched again here (piece 12).
 *
 * 🔒 Under View as the calendar is the emulated person's (decision 0602): the
 * application renders as the chosen person sees it, so the person whose events
 * and team this page reads is the one the frame is drawing as. 💰 It read the
 * real signed-in person while the server built the team from the emulated
 * employment, so the grid and the dropdown belonged to two different people
 * (product owner, 2026-09-20).
 */
export function CalendarRoute({ apiBaseUrl = '' }: { apiBaseUrl?: string }) {
  const context = useOutletContext<ShellOutletContext | undefined>();
  const personId = context?.viewingAsPersonId || context?.personId || '';
  return <CalendarPage apiBaseUrl={apiBaseUrl} personId={personId} timeZone={context?.timeZone ?? 'UTC'} />;
}
